import { WTROK0 } from "./WTROK0";

export function WTROKB () {
    return <h2 className="text-white">Bowling</h2>
}